import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Brands from './pages/Brands';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import FounderPage from './pages/Founder';
import Journey from './pages/Journey';
import Media from './pages/Media';
import Philosophy from './pages/Philosophy';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/journey" element={<Journey />} />
            <Route path="/media" element={<Media />} />
            <Route path="/insights" element={<Media />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/innovation" element={<Philosophy />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
